import axios from 'axios';

const apiRequest = async (method, body, endPoint, token, customUrl, otherParams, rawResponse = false) => {
    try {
        let showLogs = false;
        if (process.env.REACT_APP_API_URL === 'http://127.0.0.1:8000') {
            showLogs = true;
        }

        var request = {
            method,
            url: `${process.env.REACT_APP_API_URL}/api${endPoint}`,
            headers: {
                'Content-Type': 'application/json'
            }
        };

        if (body) {
            body = JSON.parse(body);
            body.domain = window.location.origin
            body.hostname = window.location.hostname
            request.data = JSON.stringify(body)
        };
        if (token) request.headers["Authorization"] = `Token ${token}`;
        if (customUrl) request.url = customUrl;
        if (otherParams && Object.keys(otherParams).length > 0) request = { ...otherParams, ...request };

        if (showLogs) {
            console.log('API Request \n', request);
        }

        const response = await axios(request);

        if (showLogs) {
            console.log('API Response \n', response);
        }

        if (customUrl || rawResponse) {
            return response;
        }
        
        return response.data.response.response_data;

    } catch (error) {
        console.log('API Error \n', error);
        return [];
    }
};

export { apiRequest };
